import { DimensionName } from 'echarts/types/src/util/types.js';

export type TabularDataEntry = (number | string | null);
export type TabularDataRow = TabularDataEntry[];
export type TabularDataRowWithHeader = [DimensionName[], TabularDataRow];
export type AspectTabularData = TabularDataRow[];

type TabularDataDTO = (string | number | null)[][];

export class AspectTabularDataDTO {
    success!: boolean;
    data!: TabularDataDTO;

    static verifyDataFormat(aspectTabularDataDTO: AspectTabularDataDTO) {
        verifyTabularRows(aspectTabularDataDTO.data);
    }

    static toAspectTabularData(aspectTabularDataDTO: AspectTabularDataDTO): AspectTabularData {
        return aspectTabularDataDTO.data;
    }
}

/** Throws unless `rows` is a header of column names followed by rows of the same width. */
export function verifyTabularRows(rows: TabularDataDTO): void {
    if (rows.length === 0) {
        throw new Error('Data contains no data');
    }

    const header = rows[0];
    if (!header.every(h => typeof h === 'string')) {
        throw new Error('Data does not contain a valid header');
    }

    const numCols = header.length;
    if (!rows.every(row => row.length === numCols)) {
        throw new Error('Data is not a valid table');
    }
}

export interface RowFilter {
    header: string;
    value: TabularDataEntry;
    isOptional: boolean;
}

export interface DateHeader {
    year: string;
    month: string;
    quarter: string;
}

export interface ValueHeader {
    value: string;
    tenYearChange: string;
    fiveYearChange: string;
    oneYearChange: string;
    oneQuarterChange: string;
    oneMonthChange: string;
}

export interface LocationHeader {
    locationId: string;
    location: string;
}

export interface ChangeHeader {
    tenYearChangePct: string;
    fiveYearChangePct: string;
    oneYearChangePct: string;
    oneQuarterChangePct: string;
    oneMonthChangePct: string;
    tenYearChangeAbs: string;
    fiveYearChangeAbs: string;
    oneYearChangeAbs: string;
    oneQuarterChangeAbs: string;
    oneMonthChangeAbs: string;
}

export type ChangePeriod = '10y' | '5y' | '1y' | '1q' | '1m';

export type DateGranularity = 'year' | 'quarter' | 'month';

export interface MultiLang<T> {
    en: T;
    fr?: T;
}
